<template>
  <div>
    <template v-if="data != 0">
      <v-icon color="primary"> mdi-fan mdi-spin </v-icon>
    </template>
    <template v-else>
      <v-icon color="primary"> mdi-fan</v-icon>
    </template>
    {{ label }} {{ index }}: <b>{{ data }} %</b>
  </div>
</template>

<script>
export default {
  name: "Fans",
  props: {
    data: {
      type: Number,
      default: 0,
      require: false,
    },
    index: {
      type: Number,
      default: 0,
      require: false,
    },
    label: {
      type: String,
      default: "",
      require: false,
    },
  },
  components: {},
  data() {
    return {};
  },
};
</script>

<style scoped></style>
